var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.44,
    height: 25.715,
    viewBox: "0 0 12.44 25.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M1249.111,784.465l-3.455-3.867,3.455-3.867a.6.6,0,0,0,.136-.582.484.484,0,0,0-.449-.367h-10.956a.512.512,0,0,0-.473.542v24.33c-1.548.043.742,0,.742,0v-15.24H1248.8a.484.484,0,0,0,.449-.367A.6.6,0,0,0,1249.111,784.465ZM1237.74,801.5Zm.372-16.932v-6.648l6.849,2.681,3.18-3.967-3.18,3.559a.572.572,0,0,0-.162.408c0,.158,1.475-2.783,1.578-2.681h-8.265Z",
    transform: "translate(-1236.832 -775.783)",
    fill: "#a71e1e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlag);
export default __webpack_public_path__ + "static/media/red_flag.d7472944e74e080366705aa456bdedc0.svg";
export { ForwardRef as ReactComponent };